module.exports = __webpack_public_path__ + "img/pending.18a8d852.png";